import affiliateAlertsApi from '../api/affiliateAlerts'

export default {
    state: {
        affiliateAlerts: {},
        filters: {},
    },
    namespaced: true,
    mutations: {
        async getAffiliateAlerts(state, affiliateAlerts) {
            state.affiliateAlerts = affiliateAlerts;
        },
        getAffiliateAlertsFilterData(state, filterData) {
            state.filters = filterData.filters;
        },
        deleteAffiliateAlert(state, id) {
            state.affiliateAlerts.data = state.affiliateAlerts.data.filter(alert => alert.id !== id);
        },
        async createOrUpdateAffiliateAlert(state, newData) {
            const currentDate = new Date();
            newData.dateUpdated = currentDate.toISOString().slice(0, 19).replace('T', ' ');

            if (newData.isEdit) {
                state.affiliateAlerts.data = state.affiliateAlerts.data.map(alert => alert.id === newData.id ? newData : alert);
            } else {
                state.affiliateAlerts.count = state.affiliateAlerts.count || 1;
                state.affiliateAlerts.data.unshift(newData);
            }
        },
    },
    actions: {
        async getAffiliateAlertsStore({ commit }, data) {
            try {
                const pagination = {
                    limit: data.limit,
                    page: data.page
                }
                const sorting = {
                    orderBy: data.orderBy,
                    orderDirectionAsc: data.orderDirectionAsc
                }
                const filters = data.filters

                const resp = await affiliateAlertsApi.getAffiliateAlerts(pagination, sorting, filters);
                commit('getAffiliateAlerts', resp);
                return resp;
            } catch (e) {
                console.error('getAffiliateAlertsStore Error:', e)
            }
        },
        async getAffiliateAlertsFilterDataStore({ commit }, data) {
            try {
                const resp = await affiliateAlertsApi.getAffiliateAlertsFilterData(data);
                commit('getAffiliateAlertsFilterData', resp);
                return resp;
            } catch (e) {
                console.error('getAffiliateAlertsFilterDataStore Error:', e)
            }
        },
        async createOrUpdateAffiliateAlertStore({ commit }, data) {
            try {
                console.log('data', data)
                const resp = await affiliateAlertsApi.createOrUpdateAffiliateAlert(data)
                if (!resp || (!resp.isSuccess && resp.id === null)) {
                    alert('Error creating alerts on backend');
                    return false;
                }
                data.id = resp.id;
                commit('createOrUpdateAffiliateAlert',data);
                return true
            } catch (e) {
                console.error('getCustomAssetsStore Error:',e)
                return false;
            }
        },
        async deleteAffiliateAlertStore({ commit }, id) {
            try {
                const resp = await affiliateAlertsApi.deleteAffiliateAlert(id);
                if (resp) {
                    commit('deleteAffiliateAlert',id);
                    return true
                } else {
                    return false
                }
            } catch (e) {
                console.error('deleteAffiliateAlertStore Error:', e)
                return false;
            }
        },
    },
    getters: {
        filters: state => state.filters,
        getAffiliateAlerts: state => state.affiliateAlerts,
    },
}
